import Tooltip from '../../../node_modules/bootstrap/js/src/tooltip';
setTimeout(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
}, 3000);
